"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrearsPermissions = void 0;
var constants_1 = require("@hobt/constants");
exports.ArrearsPermissions = {
    Create: {
        modules: [constants_1.Module.Arrears],
        roles: [
            constants_1.UserRole.ApprovedLender,
            constants_1.UserRole.BusinessUser,
            constants_1.UserRole.Clerk,
            constants_1.UserRole.MasterUser,
            constants_1.UserRole.LenderAdministrator,
            constants_1.UserRole.ServiceProvider,
        ],
    },
    CreateApprovals: {
        modules: [constants_1.Module.Arrears],
        roles: [constants_1.UserRole.BusinessUser, constants_1.UserRole.Clerk, constants_1.UserRole.MasterUser],
    },
    DeleteArrearsFile: {
        modules: [constants_1.Module.Arrears],
        roles: [constants_1.UserRole.BusinessUser, constants_1.UserRole.Clerk, constants_1.UserRole.MasterUser],
    },
    Read: {
        modules: [constants_1.Module.Arrears],
        roles: [
            constants_1.UserRole.BusinessUser,
            constants_1.UserRole.Clerk,
            constants_1.UserRole.LenderAdministrator,
            constants_1.UserRole.MasterUser,
            constants_1.UserRole.ReadOnly,
        ],
    },
    ReadActiveReportingPeriods: {
        modules: [constants_1.Module.Arrears],
        roles: [
            constants_1.UserRole.ApprovedLender,
            constants_1.UserRole.CmhcAdministrator,
            constants_1.UserRole.BusinessUser,
            constants_1.UserRole.Clerk,
            constants_1.UserRole.MasterUser,
            constants_1.UserRole.LenderAdministrator,
            constants_1.UserRole.ServiceProvider,
        ],
    },
    ReadApprovalsInventory: {
        modules: [constants_1.Module.Arrears, constants_1.Module.Claim, constants_1.Module.Default],
        roles: [constants_1.UserRole.BusinessUser, constants_1.UserRole.Clerk, constants_1.UserRole.MasterUser, constants_1.UserRole.ReadOnly],
    },
    ReadArrearsApprovals: {
        modules: [constants_1.Module.Arrears],
        roles: [constants_1.UserRole.BusinessUser, constants_1.UserRole.Clerk, constants_1.UserRole.MasterUser, constants_1.UserRole.ReadOnly],
    },
    ReadClaimArrearsData: {
        modules: [constants_1.Module.Claim],
        roles: [
            constants_1.UserRole.BusinessUser,
            constants_1.UserRole.Clerk,
            constants_1.UserRole.LenderAdministrator,
            constants_1.UserRole.MasterUser,
        ],
    },
    ReadDocumentAcl: {
        modules: [constants_1.Module.Arrears],
        roles: [
            constants_1.UserRole.ApprovedLender,
            constants_1.UserRole.BusinessUser,
            constants_1.UserRole.Clerk,
            constants_1.UserRole.LenderAdministrator,
            constants_1.UserRole.MasterUser,
            constants_1.UserRole.ServiceProvider,
        ],
    },
    ReadFiles: {
        modules: [constants_1.Module.Arrears],
        roles: [constants_1.UserRole.BusinessUser, constants_1.UserRole.Clerk, constants_1.UserRole.MasterUser, constants_1.UserRole.ReadOnly],
    },
    ReadFilesBySubmissionID: {
        modules: [constants_1.Module.Arrears],
        roles: [
            constants_1.UserRole.ApprovedLender,
            constants_1.UserRole.BusinessUser,
            constants_1.UserRole.Clerk,
            constants_1.UserRole.CmhcAdministrator,
            constants_1.UserRole.LenderAdministrator,
            constants_1.UserRole.MasterUser,
            constants_1.UserRole.ReadOnly,
            constants_1.UserRole.ServiceProvider,
        ],
    },
    ReadSummaryReports: {
        modules: [constants_1.Module.Arrears],
        roles: [constants_1.UserRole.BusinessUser, constants_1.UserRole.Clerk, constants_1.UserRole.MasterUser, constants_1.UserRole.ReadOnly],
    },
    ReadSubmission: {
        modules: [constants_1.Module.Arrears],
        roles: [
            constants_1.UserRole.ApprovedLender,
            constants_1.UserRole.BusinessUser,
            constants_1.UserRole.Clerk,
            constants_1.UserRole.LenderAdministrator,
            constants_1.UserRole.MasterUser,
            constants_1.UserRole.ReadOnly,
            constants_1.UserRole.ServiceProvider,
        ],
    },
    ReadValidation: {
        modules: [constants_1.Module.Arrears],
        roles: [constants_1.UserRole.BusinessUser, constants_1.UserRole.Clerk, constants_1.UserRole.MasterUser, constants_1.UserRole.ReadOnly],
    },
    Update: {
        modules: [constants_1.Module.Arrears],
        roles: [
            constants_1.UserRole.BusinessUser,
            constants_1.UserRole.Clerk,
            constants_1.UserRole.LenderAdministrator,
            constants_1.UserRole.MasterUser,
        ],
    },
};
